import React from "react"
import { createUseStyles } from "react-jss"
import { Container } from "../components/layout/grid"

import colors from "../styles/colors"
import { mediaQueries } from "../styles/breakpoints"
import { fontWeight, fontSize } from "../styles/fonts-constants"

const useStyles = createUseStyles({
  additionalInfo: {
    fontFamily: "'Roboto', sans-serif",
    fontSize: fontSize.small,
    fontWeight: fontWeight.normal,
    color: colors.blue5,
    lineHeight: 1.38,
    flexGrow: 1,
    padding: "50px 0",
    textAlign: "center",
    // borderTop: `1px solid ${colors.gray2}`,
    [mediaQueries.tablet]: {
      padding: "120px 0",
    },
    "& p": {
      lineHeight: 1.5,
      margin: "0 0 30px 0",
      "&:last-child": {
        marginBottom: 0,
      },
    },
    "& ul": {
      lineHeight: 1.5,
      margin: "0 0 30px 0",
    },
    "& a": {
      color: colors.blue1,
      "&:hover": {
        color: colors.blue19,
        textDecoration: "underline !important",
      },
    },
  },
  textLeft: {
    textAlign: "left",
  },
})

const AdditionalInfo = (props) => {
  const { children, textLeft = false } = props

  const classes = useStyles()

  return (
    <div
      className={`${classes.additionalInfo} ${
        textLeft ? classes.textLeft : ""
      }`}
    >
      <Container>{children}</Container>
    </div>
  )
}
export default AdditionalInfo
